import { render, staticRenderFns } from "./GoogleButton.vue?vue&type=template&id=7d41fe00&scoped=true&"
import script from "./GoogleButton.vue?vue&type=script&lang=js&"
export * from "./GoogleButton.vue?vue&type=script&lang=js&"
import style0 from "./GoogleButton.vue?vue&type=style&index=0&id=7d41fe00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d41fe00",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BButton} from 'bootstrap-vue'
    installComponents(component, {BButton})
    

export default component.exports